import { render } from "./AssetsLiveAccount.vue?vue&type=template&id=1041221a&scoped=true"
import script from "./AssetsLiveAccount.vue?vue&type=script&lang=js"
export * from "./AssetsLiveAccount.vue?vue&type=script&lang=js"

import "./AssetsLiveAccount.vue?vue&type=style&index=0&id=1041221a&lang=less&scoped=true"

import exportComponent from "/home/data/jenkins/workspace/Pro_TWI_T/Pro_TWI_h5_advantrade-website/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1041221a"]])

export default __exports__